// extracted by mini-css-extract-plugin
export default {"title":"NuovoDipendente_title__uxkVF","cardContainer":"NuovoDipendente_cardContainer__zan8r","buttonNewSede":"NuovoDipendente_buttonNewSede__nI-s2"};